import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Solicitacao } from '@/types/solicitacao';
import { useClientFilter } from './useClientFilter';

export const useSolicitacoesTechnician = () => {
  const { 
    currentClientId, 
    isAdmin, 
    isTechnician, 
    clientLoading, 
    getTechnicianFilter,
    applyClientFilter 
  } = useClientFilter();
  
  const { data: solicitacoes = [], isLoading, error } = useQuery({
    queryKey: ['solicitacoes-technician', currentClientId, isAdmin, isTechnician],
    queryFn: async () => {
      let query = supabase
        .from('solicitacoes')
        .select(`
          *,
          categoria:categorias_servico(nome),
          sla:slas(nome),
          solicitante:users!solicitacoes_solicitante_id_fkey(name),
          cliente:clients(name),
          grupo_responsavel:groups(name),
          atendente:users!solicitacoes_atendente_id_fkey(name)
        `);

      if (isAdmin) {
        // Admin vê tudo
      } else if (isTechnician) {
        const techFilter = getTechnicianFilter();
        
        if (techFilter?.clientIds.length > 0 || techFilter?.groupIds.length > 0) {
          let orConditions = [];
          
          if (techFilter.clientIds.length > 0) {
            orConditions.push(`client_id.in.(${techFilter.clientIds.join(',')})`);
          }
          
          if (techFilter.groupIds.length > 0) {
            orConditions.push(`grupo_responsavel_id.in.(${techFilter.groupIds.join(',')})`);
          }
          
          if (orConditions.length > 0) {
            query = query.or(orConditions.join(','));
          }
        } else {
          return [];
        }
      } else {
        query = applyClientFilter(query, 'client_id');
      }

      const { data, error } = await query.order('criado_em', { ascending: false });

      if (error) {
        console.error('Error fetching solicitações:', error);
        throw error;
      }

      return data as Solicitacao[];
    },
    enabled: !clientLoading,
  });

  return {
    solicitacoes,
    isLoading,
    error,
  };
};
